import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { UserType, getUserTypeDisplayName, getUserTypeIcon } from '../types/userTypes'
import { Icon } from '../components/Icon'
import { AnalyticsContext } from '../analytics/AnalyticsContext'

const SelectUserTypePopup: React.FC<{
  userType: UserType | null
  onConfirm: (userType: UserType) => void
  onClose?: () => void
  inline?: boolean
}> = ({
  userType,
  onConfirm,
  onClose,
  inline,
}) => {

  const analyticsLogger = React.useContext(AnalyticsContext)

  return (
    <Popup
      inline={inline}
      onClose={() => onClose?.()}
    >
      <div className="SelectUserTypePopup">
        <div className="title center">
          Help us customise your experience.
          <p>
            I am a:
          </p>
        </div>
        <div className="buttonRow">
          {
            [UserType.Consumer, UserType.Electrician].map(option => (
              <Button
                key={option}
                buttonStyle="green"
                onClick={() => {
                  if (option === userType) {
                    onClose ? onClose() : onConfirm(option)
                  } else {
                    analyticsLogger.log({
                      event: 'cta_click',
                      cta_name: option,
                      cta_link: null,
                      cta_category: 'Button',
                      cta_location: 'Select user type dialog'
                    })

                    onConfirm(option)
                  }
                }}
              >
                <Icon color="white" size={18} source={getUserTypeIcon(option)}/>
                <div style={{ marginLeft:10 }}>{getUserTypeDisplayName(option)}</div>
              </Button>
            ))
          }
        </div>
      </div>
    </Popup>
  )
}

export default SelectUserTypePopup
